<template>
  <v-dialog
    v-model="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    max-width="360"
    :retain-focus="false"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-3"
          medium
          >{{ icon }}</v-icon
        >
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn text medium @click="clickYes" style="min-width: 0; width: 20px">
          <v-icon
            medium
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            >mdi-close-box</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6 pb-6">
        <v-checkbox
          style="height: 35px"
          class="pa-0 ma-0 mx-1 mt-1"
          v-model="isGradient"
          :label="$t('fabricColorPickerActivateGradientTitle')"
        ></v-checkbox>
        <v-color-picker
          flat
          :hide-mode-switch="true"
          show-swatches
          hide-canvas
          hide-inputs
          :dot-size="20"
          v-model="cColor"
          :swatches-max-height="$vuetify.breakpoint.height / 1.8"
        />
      </v-card-text>
      <v-card-actions
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
      >
        <v-spacer></v-spacer>
        <v-btn color="primary" text class="mx-0" @click="clickYes">{{
          $t("lmBtnClose")
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-color-picker",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    gradient: {
      type: Boolean,
      required: false,
    },
    initColor: {
      type: String,
      required: true,
    },
  },
  computed: {
    isGradient: {
      get: function () {
        return this.gradient;
      },
      set: function (newValue) {
        console.log(newValue);
        this.$emit("gradientChecked", newValue);
      },
    },
    cColor: {
      get: function () {
        return this.initColor;
      },
      set: function (newValue) {
        console.log(newValue);
        this.$emit("selectedColor", newValue);
      },
    },
  },
  methods: {
    selectedColor: function (newValue) {
      this.$emit("selectedColor", newValue);
    },
    clickYes: function () {
      this.$emit("clickYes");
    },
  },
};
</script>

<style scoped>
</style>